import React from 'react';
import Input from "../../../PopUp/Input";
import BaseField from '../BaseField/BaseField';

interface TextFieldProps {
  id?: string;
  title?: string;
  label?: string;
  displayName?: string;
  showTitle?: boolean;
  value?: string;
  placeholder?: string;
  onChangeValue?: (value: string) => void;
  disabled?: boolean;
  isSelected?: boolean;
  exclusionType?: 'hide' | 'disable';
}

const TextField = ({ id = 'text-field-input', title = 'Title', label = 'Text Field', displayName, showTitle = true, value = '', placeholder = '', onChangeValue = () => {}, disabled = false, isSelected = false }: TextFieldProps) => {
  const baseId = id || 'text-field';

  const displayLabel = showTitle && displayName ? displayName : (showTitle ? label : '');

  return (
    <BaseField
      id={baseId}
      label={displayLabel}
      isSelected={isSelected}
      showTitle={showTitle}
    >
      <Input
        id={`${baseId}-input`}
        className="tw-w-full"
        placeholder={placeholder}
        value={value}
        onChangeValue={onChangeValue}
      />
    </BaseField>
  );
};

export default TextField;